import { AxiosInstance } from 'axios';
import { Params as _Params } from '../types';

export type Params = _Params;

export enum Statuses {
  ERROR = 'error',
  READY = 'ready',
  STADY = 'stady',
  WAITING = 'waiting',
}

export interface Providers {
  $api: AxiosInstance;
}

export interface Review {
  fio: string;
  photo?: string;
  rate: number;
  text: string;
}

export interface ReviewFetched extends Review {
  date: string;
}

export interface ReviewSaved extends Review {
  date: Date;
}

export interface State {
  status: Statuses;
  reviews: Reviews;
}

export type ReviewsFetched = Array<ReviewFetched>;
export type Reviews = Array<ReviewSaved>;



// WEBPACK FOOTER //
// ./src/pages/organizations/card/reviews/types.ts